import { BrowserRouter, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { SocialMediaIconsReact } from "social-media-icons-react";

const Footer = () => {
  return (
    <BrowserRouter>
      <div id="footer" className="footer-container">
        <div className="footer-links-container">
          <h2 className="footer-links-title" data-aos="fade-right">
            Page Links
          </h2>
          <div className="footer-links">
            <HashLink
              to="#hero"
              smooth
              className="footer-link footer-link--home"
              data-aos="fade-right"
              data-aos-delay="50"
            >
              Home
            </HashLink>
            <HashLink
              to="#carousel"
              smooth
              className="footer-link footer-link--about"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              About
            </HashLink>
            <HashLink
              to="#more-features"
              smooth
              className="footer-link footer-link--services"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              Services
            </HashLink>
            <HashLink
              to="#footer"
              smooth
              className="footer-link footer-link--settings"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              Settings
            </HashLink>
          </div>
        </div>
        <div className="footer-section">
          <div className="social-media-links">
            <div
              data-aos="fade-left"
              data-aos-duration="100"
              data-aos-delay="50"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="facebook"
                iconColor="#ffffff"
                roundness="30%"
                url="https://www.facebook.com/JetBrains"
                size="30"
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="200"
              data-aos-delay="100"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="instagram"
                iconColor="#ffffff"
                roundness="30%"
                backgroundColor="rgb(255,70,255)"
                url="https://www.instagram.com/jetbrains/"
                size="30"
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="300"
              data-aos-delay="150"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="twitter"
                iconColor="#ffffff"
                roundness="30%"
                url="https://www.twitter.com/jetbrains"
                size="30"
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="400"
              data-aos-delay="200"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="linkedin"
                iconColor="#ffffff"
                roundness="30%"
                url="https://www.linkedin.com/company/jetbrains/"
                size="30"
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="250"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="youtube-play"
                iconColor="#ffffff"
                roundness="30%"
                url="https://www.youtube.com/user/JetBrainsTV"
                size="30"
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="600"
              data-aos-delay="300"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="web"
                iconColor="#ffffff"
                backgroundColor="darkblue"
                roundness="30%"
                url="https://blog.jetbrains.com/"
                size="30"
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="700"
              data-aos-delay="350"
            >
              <SocialMediaIconsReact
                borderColor="transparent"
                borderWidth="0"
                borderStyle="none"
                icon="rss"
                iconColor="#ffffff"
                roundness="30%"
                url="https://blog.jetbrains.com/feed/"
                size="30"
              />
            </div>
          </div>
          <div className="jetbrains-info">
            <Link
              to="https://www.jetbrains.com/privacy-security/"
              className="jetbrains-link"
              data-aos="fade-left"
              data-aos-delay="500"
            >
              Privacy & Security
            </Link>
            <Link
              to="https://www.jetbrains.com/legal/docs/company/useterms.html"
              className="jetbrains-link"
              data-aos="fade-left"
              data-aos-delay="550"
            >
              Terms of Use
            </Link>
            <Link
              to="https://www.jetbrains.com/legal/trademarks/"
              className="jetbrains-link"
              data-aos="fade-left"
              data-aos-delay="600"
            >
              Trademarks
            </Link>
            <Link
              to="https://www.jetbrains.com/legal/legal/"
              className="jetbrains-link"
              data-aos="fade-left"
              data-aos-delay="650"
            >
              Legal
            </Link>
            <Link
              to="https://www.jetbrains.com/legal/genuine-tools/"
              className="jetbrains-link"
              data-aos="fade-left"
              data-aos-delay="700"
            >
              Genuine Tools
            </Link>
          </div>
          <p className="copyright">
            Copyright &copy; 2000-2022 JetBrains s.r.o.
          </p>
        </div>
        <div className="footer-extra">
          <p className="extra-text">
            Developed with drive and{" "}
            <a href="https://jetbrains.com/idea" className="footer-IDEA">
              IntelliJ IDEA
            </a>
          </p>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Footer;
